import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

const baseUrl = 'https://ebaybaymo-server-b084d082cda7.herokuapp.com/';

const Wrap = styled.div`
  max-width: 10000px;
  margin: 0 auto;
  padding: 2rem;
  font-family: 'Inter', sans-serif;
  background: linear-gradient(90deg, rgb(170, 39, 13), rgb(231, 145, 91));
  min-height: 100vh;
  border-radius: 12px;
  overflow-y: auto;
  color: #fff;

  @media (max-width: 768px) {
    padding: 1rem;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    padding: 0.75rem;
  }
`;

const Heading = styled.h1`
  margin: 0 0 1rem;
  font-size: 2rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;

const SubText = styled.p`
  margin: 0 0 1.25rem;
  color: rgba(255, 255, 255, 0.9);

  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 0.9rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
    margin-bottom: 0.7rem;
  }
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.96);
  border-radius: 12px;
  padding: 1rem;
  color: #1f2937;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);

  @media (max-width: 768px) {
    padding: 0.75rem;
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
    border-radius: 8px;
  }
`;

const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.7rem;
  margin-bottom: 0.9rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Input = styled.input`
  padding: 0.55rem 0.8rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  min-width: 230px;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

const Select = styled.select`
  padding: 0.55rem 0.8rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TableWrap = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 8px;

  @media (max-width: 768px) {
    max-height: 500px;
    overflow-y: auto;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;

  th,
  td {
    padding: 0.75rem;
    border-bottom: 1px solid #e5e7eb;
    text-align: left;
    white-space: nowrap;
  }

  th {
    background: #111827;
    color: #fff;
    position: sticky;
    top: 0;
    font-size: 0.9rem;
  }

  @media (max-width: 768px) {
    min-width: 100%;
    font-size: 0.85rem;

    th,
    td {
      padding: 0.5rem;
    }
  }

  @media (max-width: 480px) {
    font-size: 0.75rem;

    th,
    td {
      padding: 0.4rem;
    }
  }
`;

const ActionsWrap = styled.div`
  display: flex;
  gap: 0.45rem;
  flex-direction: row;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 0.3rem;
  }
`;

const ActionButton = styled.button`
  border: 1px solid ${(props) => (props.$variant === 'accept' ? '#16a34a' : '#d97706')};
  background: ${(props) => (props.$variant === 'accept' ? '#dcfce7' : '#fef3c7')};
  color: ${(props) => (props.$variant === 'accept' ? '#166534' : '#92400e')};
  border-radius: 8px;
  padding: 0.3rem 0.55rem;
  font-weight: 700;
  font-size: 0.78rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    padding: 0.25rem 0.4rem;
    font-size: 0.7rem;
  }
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: capitalize;
  background: ${(props) => (props.status === 'accepted' ? '#dcfce7' : '#fef3c7')};
  color: ${(props) => (props.status === 'accepted' ? '#166534' : '#92400e')};
`;

const Empty = styled.div`
  padding: 1.2rem;
  color: #64748b;
  text-align: center;

  @media (max-width: 480px) {
    padding: 0.8rem;
    font-size: 0.9rem;
  }
`;

const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;

  @media (max-width: 480px) {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
  }
`;

const SeeMoreButton = styled.button`
  background: #d97706;
  border: none;
  color: #fff;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);

  &:hover {
    background: #b45309;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 0.65rem 1.2rem;
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    padding: 0.55rem 1rem;
    font-size: 0.85rem;
    width: 100%;
  }
`;

const RefreshButton = styled.button`
  background: #0ea5e9;
  border: none;
  color: #fff;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.55rem 1rem;
  border-radius: 6px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  white-space: nowrap;

  &:hover {
    background: #0284c7;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const normalizeStatus = (value) => {
  const s = String(value || 'pending').toLowerCase();
  if (['accepted', 'approved', 'confirmed'].includes(s)) return 'accepted';
  return 'pending';
};

const readLocalHennaAppointments = () => {
  try {
    const raw = localStorage.getItem('hennaAppointments');
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch (error) {
    return [];
  }
};

const AdminHennaBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [updatingId, setUpdatingId] = useState(null);
  const [visibleBookings, setVisibleBookings] = useState(999);
  const [lastRefresh, setLastRefresh] = useState(new Date());

  const fetchBookings = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${baseUrl}henna/bookings`);
      if (!response.ok) throw new Error('Endpoint unavailable');

      const payload = await response.json();
      console.log('Henna Bookings Response:', payload);
      const rows = Array.isArray(payload) ? payload : payload.data || [];
      console.log('Parsed rows:', rows);
      const normalizedRows = rows.map((item) => ({
        ...item,
        status: normalizeStatus(item.status || item.booking_status),
      }));

      setBookings(normalizedRows);
      setLastRefresh(new Date());
    } catch (error) {
      console.error('Error fetching henna bookings:', error);
      const localRows = readLocalHennaAppointments().map((item) => ({
        ...item,
        status: normalizeStatus(item.status),
      }));
      setBookings(localRows);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();

    // Auto-refresh every 30 seconds to show new bookings from other computers
    const interval = setInterval(() => {
      fetchBookings();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setVisibleBookings(999);
  }, [search, statusFilter]);

  const filteredBookings = useMemo(() => {
    return bookings.filter((item) => {
      const status = normalizeStatus(item.status || item.booking_status);
      const packageName = item.package_name || item.package_code || '';
      const fullName = item.full_name || item.fullName || '';
      const email = item.email || '';
      const userId = String(item.user_id || '');

      const matchesStatus = statusFilter === 'all' || status === statusFilter;
      const haystack = `${packageName} ${fullName} ${email} ${userId}`.toLowerCase();
      const matchesSearch = haystack.includes(search.toLowerCase());
      return matchesStatus && matchesSearch;
    });
  }, [bookings, search, statusFilter]);

  const handleSeeMore = () => {
    setVisibleBookings((prev) => prev + 10);
  };

  const updateLocalStorageStatus = (appointmentId, status) => {
    try {
      const raw = localStorage.getItem('hennaAppointments');
      const parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return;

      const updated = parsed.map((item) => {
        if (String(item.appointment_id) === String(appointmentId)) {
          return { ...item, status: normalizeStatus(status) };
        }
        return item;
      });

      localStorage.setItem('hennaAppointments', JSON.stringify(updated));
    } catch (error) {
      // Ignore local storage update failure.
    }
  };

  const handleStatusUpdate = async (appointmentId, nextStatus) => {
    if (!appointmentId) return;

    const normalizedStatus = normalizeStatus(nextStatus);
    setUpdatingId(String(appointmentId));

    // Optimistic UI update so admin sees instant feedback.
    setBookings((prev) =>
      prev.map((item) =>
        String(item.appointment_id) === String(appointmentId)
          ? { ...item, status: normalizedStatus }
          : item
      )
    );

    try {
      const response = await fetch(`${baseUrl}henna/bookings/${appointmentId}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: normalizedStatus }),
      });

      if (!response.ok) {
        throw new Error('Status update endpoint unavailable.');
      }
    } catch (error) {
      // Keep local fallback so admin decision still applies in this environment.
    } finally {
      updateLocalStorageStatus(appointmentId, normalizedStatus);
      setUpdatingId(null);
    }
  };

  return (
    <Wrap>
      <Heading>Henna Bookings</Heading>
      <SubText>Total: {bookings.length} bookings | Filtered: {filteredBookings.length} | Showing: {Math.min(visibleBookings, filteredBookings.length)} | Last updated: {lastRefresh.toLocaleTimeString()}</SubText>

      <Card>
        <Toolbar>
          <Input
            placeholder="Search by name, email, package, user ID"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          <Select value={statusFilter} onChange={(event) => setStatusFilter(event.target.value)}>
            <option value="all">All status</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
          </Select>
          <RefreshButton onClick={fetchBookings} disabled={loading}>
            {loading ? 'Refreshing...' : 'Refresh Now'}
          </RefreshButton>
        </Toolbar>

        {loading ? (
          <Empty>Loading henna bookings...</Empty>
        ) : error ? (
          <Empty>{error}</Empty>
        ) : filteredBookings.length === 0 ? (
          <Empty>No henna bookings found.</Empty>
        ) : (
          <>
            <TableWrap>
              <Table>
                <thead>
                  <tr>
                    <th>Appointment ID</th>
                    <th>User ID</th>
                    <th>Client Name</th>
                    <th>Email</th>
                    <th>Package</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Status</th>
                    <th>Actions</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredBookings.slice(0, visibleBookings).map((item, index) => {
                  const status = normalizeStatus(item.status || item.booking_status);
                  return (
                    <tr key={item.appointment_id || item.reference || `${item.user_id || 'u'}-${index}`}>
                      <td>{item.appointment_id || item.reference || '-'}</td>
                      <td>{item.user_id ?? '-'}</td>
                      <td>{item.full_name || item.fullName || '-'}</td>
                      <td>{item.email || '-'}</td>
                      <td>{item.package_name || item.package_code || '-'}</td>
                      <td>{item.appointment_date || item.date || '-'}</td>
                      <td>{item.appointment_time || item.time || '-'}</td>
                      <td>
                        <StatusBadge status={status}>{status}</StatusBadge>
                      </td>
                      <td>
                        <ActionsWrap>
                          <ActionButton
                            type="button"
                            $variant="accept"
                            disabled={updatingId === String(item.appointment_id)}
                            onClick={() => handleStatusUpdate(item.appointment_id, 'accepted')}
                          >
                            Accept
                          </ActionButton>
                          <ActionButton
                            type="button"
                            $variant="pending"
                            disabled={updatingId === String(item.appointment_id)}
                            onClick={() => handleStatusUpdate(item.appointment_id, 'pending')}
                          >
                            Set Pending
                          </ActionButton>
                        </ActionsWrap>
                      </td>
                      <td>{item.notes || '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </TableWrap>
          {visibleBookings < filteredBookings.length && (
            <ButtonWrapper>
              <SeeMoreButton onClick={handleSeeMore}>See More</SeeMoreButton>
            </ButtonWrapper>
          )}
          </>
        )}
      </Card>
    </Wrap>
  );
};

export default AdminHennaBookings;
